// src/components/NewsletterSignup/NewsletterSignup.jsx
import React, { useState } from 'react';
import './NewsletterSignup.css';

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/moeaeepl';

const NewsletterSignup = ({ idPrefix = 'news' }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    newsletterConsent: false,
    privacyConsent: false,
  });
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(e.target),
      });
      if (res.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', newsletterConsent: false, privacyConsent: false });
      } else {
        setStatus('error');
      }
    } catch (err) {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return <div className="form-success">Thanks for joining our mailing list!</div>;
  }

  return (
    <form className="newsletter-form" onSubmit={handleSubmit}>
      <input type="hidden" name="form_type" value="Mailing List Signup" />

      <div className="form-row">
        <label htmlFor={`${idPrefix}-name`}>Name</label>
        <input
          id={`${idPrefix}-name`}
          name="name"
          type="text"
          required
          value={formData.name}
          onChange={handleChange}
        />
      </div>

      <div className="form-row">
        <label htmlFor={`${idPrefix}-email`}>Email</label>
        <input
          id={`${idPrefix}-email`}
          name="email"
          type="email"
          required
          value={formData.email}
          onChange={handleChange}
        />
      </div>

      <div className="form-row-checkbox">
        <input
          id={`${idPrefix}-newsletter-consent`}
          name="newsletterConsent"
          type="checkbox"
          required
          checked={formData.newsletterConsent}
          onChange={handleChange}
        />
        <label htmlFor={`${idPrefix}-newsletter-consent`}>
          I&rsquo;d like to receive the PointeSense newsletter and product updates by email.
        </label>
      </div>

      <div className="form-row-checkbox">
        <input
          id={`${idPrefix}-privacy-consent`}
          name="privacyConsent"
          type="checkbox"
          required
          checked={formData.privacyConsent}
          onChange={handleChange}
        />
        <label htmlFor={`${idPrefix}-privacy-consent`}>
          I agree to the <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
        </label>
      </div>

      <button type="submit" className="newsletter-button" disabled={status === 'submitting'}>
        {status === 'submitting' ? 'Joining...' : 'Join the Mailing List'}
      </button>

      {status === 'error' && (
        <p className="form-error">Something went wrong. Please try again or email us directly.</p>
      )}

      <p className="newsletter-unsubscribe-note">You can unsubscribe at any time.</p>
    </form>
  );
};

export default NewsletterSignup;
